import React, { useEffect, useRef, useState } from 'react';
import { LocalDBProvider } from './src/shared/data/LocalDB';
import { Animated, Image, View } from 'react-native';
import InvisibleHeader from './src/specific/components/Main/InvisibleHeader';
import MenuCell from './src/shared/components/Menu/MenuCell';
import { generatePath, NavigateFunction, NavLink, BrowserRouter as Router, useNavigate } from 'react-router-dom';
import AnimatedRoutes from './src/specific/utils/Navigation/AnimatedRoutes';
import User from './src/shared/data/user/User';
import Images, { bundleImage } from './src/specific/utils/Images';
import { APP_MENU_SCREENS } from './src/shared/components/Menu/Menu';
import { EventMenuSelectedChanged, ScreenActivitiesMenu, ScreenSequencesMenu } from './src/shared/utils/Constants';
import { AppTarget, getAppTarget, getHost } from './src/specific/utils/Navigation/Host';
import DeepLink from './src/shared/services/DeepLink/DeepLink';
import { EventRegister } from './src/shared/utils/EventListeners';
import AppTheme from './src/shared/utils/Theme';

interface SideMenuProps {
    onChange: () => void
}

const SideMenu = (props: SideMenuProps) => {

    const { onChange } = props
    const appTheme: AppTheme = new AppTheme();

    const user: User = User.getInstance();
    const images: Images = new Images();

    const navigate: NavigateFunction = useNavigate();

    const [selectedMenuScreen, setSelectedMenuScreen] = useState<APP_MENU_SCREENS>("ACTIVITIES");
    const [menuSelectedForBackground, setMenuSelectedForBackground] = useState<APP_MENU_SCREENS>("ACTIVITIES");

    let imagesForProfile: number | bundleImage = images.icLiliAtSchoolCircle;
    if (user.profile === "family") {
        imagesForProfile = images.icLiliAtHomeCircle;
    } else if (user.profile === "animator") {
        imagesForProfile = images.icLiliAtExtracurricularCircle;
    }

    useEffect(() => {
        EventRegister.addEventListener(EventMenuSelectedChanged, (menu: APP_MENU_SCREENS) => {
            setSelectedMenuScreen(menu);
        });
        return () => {
            EventRegister.removeEventListener(EventMenuSelectedChanged);
        };
    }, []);

    useEffect(() => {
        setMenuSelectedForBackground(selectedMenuScreen);
    }, [selectedMenuScreen]);

    const onNewMenuSelected = (selectedMenu: APP_MENU_SCREENS) => {
        let pathname: string = "/appMenu/" + selectedMenu.toLocaleLowerCase();
        const deepLink: DeepLink = DeepLink.getInstance();
        deepLink.path = pathname;
        console.log({ deepLink });
        navigate(pathname, { replace: true, state: { back: false } });
        setSelectedMenuScreen(selectedMenu);
    }

    const appTarget: AppTarget = getAppTarget();
    if (appTheme.getFlexDirectionForSplitScreen() === "column") {
        onChange();
        return <View />
    }
    if ((appTarget === "public") || (appTarget === "lhq")) {
        if ((user.currentUser === null) || (window.location.href === "https://localhost:1234/") || (window.location.href === "https://app.lili.cool/") || (window.location.href === "https://lili-dev-608f0.web.app/")) {
            return <View />
        }
    }
    let width: number = appTheme.getFullAppWidth();
    let premiumCell: React.JSX.Element | null = null;
    if (user.isPremium() === false) {
        //premiumCell = <MenuCell width={width} menuScreenId="PREMIUM" isSelected={selectedMenuScreen === "PREMIUM"} onSelectedMenuChange={onNewMenuSelected} />;
    }
    onChange();
    return <View style={{ position: "fixed", width: 200, height: window.innerHeight, backgroundColor: "#ffffff", zIndex: 200, alignItems: "center", paddingVertical: 20 }}>
        <Image source={imagesForProfile} style={{ width: 120, height: 120, marginBottom: 20 }} resizeMode="contain" />
        <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
            <MenuCell width={120} menuScreenId="ACTIVITIES" isSelected={menuSelectedForBackground === "ACTIVITIES"} onSelectedMenuChange={onNewMenuSelected} />
            <MenuCell width={120} menuScreenId="SEQUENCES" isSelected={menuSelectedForBackground === "SEQUENCES"} onSelectedMenuChange={onNewMenuSelected} />
            <MenuCell width={120} menuScreenId="ROOM" isSelected={menuSelectedForBackground === "ROOM"} onSelectedMenuChange={onNewMenuSelected} />
            {premiumCell}
            <MenuCell width={120} menuScreenId="ACCOUNT" isSelected={menuSelectedForBackground === "ACCOUNT"} onSelectedMenuChange={onNewMenuSelected} />
        </View>
    </View>
}

const App = () => {

    const user: User = User.getInstance();
    const paddingLeft: Animated.Value = useRef(new Animated.Value(0)).current;
    const appTheme: AppTheme = new AppTheme();

    const onChange = () => {
        if (appTheme.getFlexDirectionForSplitScreen() === "row") {
            Animated.timing(paddingLeft, {
                toValue: 200,
                duration: 200,
                useNativeDriver: false
            }).start();
        } else {
            Animated.timing(paddingLeft, {
                toValue: 0,
                duration: 200,
                useNativeDriver: false
            }).start();
        }
    }

    return <LocalDBProvider>
        <View style={{ width: window.innerWidth, height: window.innerHeight }}>
            <Router>
                <View style={{ flex: 1 }}>
                    <View style={{ position: "sticky", zIndex: 100, top: 0, width: window.innerWidth }}>
                        <InvisibleHeader />
                    </View>
                    <View style={{ flex: 1, flexDirection: "row", width: window.innerWidth, height: window.innerHeight }}>
                        <SideMenu onChange={onChange} />
                        <Animated.View style={{ paddingLeft }}>
                            <AnimatedRoutes />
                        </Animated.View>
                    </View>
                </View>
            </Router>
        </View>
    </LocalDBProvider>
}

export default App;